import {
  GET_CONTACT_US_CATEGORIES_REQUEST,
  GET_CONTACT_US_CATEGORIES_SUCCESS,
  GET_CONTACT_US_CATEGORIES_FAILURE,
  GET_AUTH_CONTACT_US_CATEGORIES_REQUEST,
  GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS,
  GET_AUTH_CONTACT_US_CATEGORIES_FAILURE,
  GET_CAPTCHA_HASH_REQUEST,
  GET_CAPTCHA_HASH_SUCCESS,
  GET_CAPTCHA_HASH_FAILURE,
  CAPTCHA_VERIFY_REQUEST,
  CAPTCHA_VERIFY_SUCCESS,
  CAPTCHA_VERIFY_FAILURE
} from 'Store/constants';

const initialState = {
  verifiedData: [],
  hashData: [],
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_US_CATEGORIES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_CONTACT_US_CATEGORIES_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_CONTACT_US_CATEGORIES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_AUTH_CONTACT_US_CATEGORIES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_AUTH_CONTACT_US_CATEGORIES_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_AUTH_CONTACT_US_CATEGORIES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_CAPTCHA_HASH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_CAPTCHA_HASH_SUCCESS:
      return { ...state, hashData: action.payload, isLoading: false, error: null };
    case GET_CAPTCHA_HASH_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case CAPTCHA_VERIFY_REQUEST:
      return { ...state, isLoading: true, error: null };
    case CAPTCHA_VERIFY_SUCCESS:
      return {  data: [...state.data, ...action.payload],
        isLoading: false,
        error: null };
    case CAPTCHA_VERIFY_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
